"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPickerYearMonthForm = void 0;
const react_1 = __importDefault(require("react"));
const dateUtils = __importStar(require("../../utils/dateUtils"));
/**
 * Form for selecting the year and month in dropdowns.
 */
const DayPickerYearMonthForm = (props) => {
    const months = dateUtils.MONTHS;
    const years = [];
    for (let i = props.minYear; i <= props.maxYear; i += 1) {
        years.push(i);
    }
    return (react_1.default.createElement("div", { className: "DayPicker-Caption" },
        react_1.default.createElement("select", { className: "month-select", name: "month", onChange: (e) => props.onChange(new Date(props.date.getFullYear(), parseInt(e.target.value))), value: props.date.getMonth() }, months.map((month, i) => (react_1.default.createElement("option", { key: month, value: i }, month)))),
        react_1.default.createElement("select", { className: "year-select", name: "year", onChange: (e) => props.onChange(new Date(parseInt(e.target.value), props.date.getMonth())), value: props.date.getFullYear() }, years.map((year) => (react_1.default.createElement("option", { key: year, value: year }, year))))));
};
exports.DayPickerYearMonthForm = DayPickerYearMonthForm;
